import {
  AllPodcastsSocialStatsArgs,
  GetRequestStatusArgs,
  SocialPlatform,
} from 'api/services';

export const embedVideoQueries = {
  all: [{ scope: 'socialShareStats' }] as const,
  videos: (episodeId?: string) =>
    [{ ...embedVideoQueries.all[0], episodeId }] as const,
  request: (args: GetRequestStatusArgs) =>
    [{ ...embedVideoQueries.all[0], ...args }] as const,
  podcasts: (args?: AllPodcastsSocialStatsArgs) =>
    [{ ...embedVideoQueries.all[0], entity: 'podcasts', ...args }] as const,
  podcast: (podcastId?: string, platform?: SocialPlatform[]) =>
    [{ ...embedVideoQueries.podcasts(), podcastId, platform }] as const,
};
